/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { aiConfigsUpdateTargeting } from "../../funcs/aiConfigsUpdateTargeting.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.PatchAIConfigTargetingRequest$inboundSchema,
};

export const tool$aiConfigsUpdateTargeting: ToolDefinition<typeof args> = {
  name: "update-ai-config-targeting",
  description: `Updates the targeting of an existing AI Config.`,
  scopes: ["write"],
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await aiConfigsUpdateTargeting(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
